/* eslint-disable no-unused-vars */
import moment from 'moment';
import numeral from 'numeral';
import { getLocale } from './utils/leads';

export function currencyNumber(currency, value) {
  if (currency === 'USD') {
    return `USD ${numeral(value).format()}`;
  }
  return `${getLocale().currency.symbol} ${numeral(value).format()} `;
}

export function formatNumber(value) {
  return numeral(value).format();
}

function initFormatNumeral() {
  numeral.defaultFormat('0,0.[00]');
  numeral.register('locale', getLocale().locale, getLocale());
  numeral.locale(getLocale().locale);
}

export default initFormatNumeral;
